export default __webpack_public_path__ + "static/media/AutoWin_159x150.66d5c00b.png";